package ru.notamedia.qah

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import ru.notamedia.qah.screens.home.HomeScreen
import ru.notamedia.qah.screens.qa_json_validator.QAJsonValidatorScreen

enum class Screen {
    HOME,
    QA_PARSER,
}

class NavController() {

    internal var currentScreen by mutableStateOf(Screen.HOME)

    fun navigate(screen: Screen) {
        currentScreen = screen
    }

    fun back() {
        currentScreen = Screen.HOME
    }
}

@Composable
fun App() {
    MaterialTheme {
        val navController = remember { NavController() }

        when (navController.currentScreen) {
            Screen.HOME -> HomeScreen(navController)
            Screen.QA_PARSER -> QAJsonValidatorScreen(navController)
        }
    }
}
